var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("\n    Front end: "+_vm._s(_vm.frontEndVersion)+" "),_c('br'),_vm._v("\n    Back end: "+_vm._s(_vm.backEndVersion)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }